var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconVolumeOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.41406C13.0544 4.41406 13.9182 5.22994 13.9945 6.2648L14 6.41406V17.5856C14 18.1161 13.7893 18.6248 13.4142 18.9998C12.6743 19.7398 11.4988 19.7787 10.713 19.1167L10.5858 18.9998L7.58579 15.9998H5C3.94564 15.9998 3.08183 15.184 3.00549 14.1491L3 13.9998V9.99985C3 8.94549 3.81588 8.08168 4.85074 8.00533L5 7.99985H7.58579L10.5858 4.99985C10.9609 4.62478 11.4696 4.41406 12 4.41406ZM12 6.41406L8.70711 9.70696C8.55083 9.86324 8.34815 9.96245 8.13144 9.99118L8 9.99985H5V13.9998H8C8.22101 13.9998 8.43448 14.073 8.60803 14.2059L8.70711 14.2927L12 17.5856V6.41406ZM16.6129 9.20955L16.7071 9.29274L18 10.5851L19.2929 9.29274C19.6834 8.90222 20.3166 8.90222 20.7071 9.29274C21.0976 9.68327 21.0976 10.3164 20.7071 10.707L19.414 11.9991L20.7071 13.2927C21.0976 13.6833 21.0976 14.3164 20.7071 14.707C20.3466 15.0674 19.7794 15.0952 19.3871 14.7901L19.2929 14.707L18 13.4141L16.7071 14.707C16.3166 15.0975 15.6834 15.0975 15.2929 14.707C14.9024 14.3164 14.9024 13.6833 15.2929 13.2927L16.585 11.9991L15.2929 10.707C14.9024 10.3164 14.9024 9.68327 15.2929 9.29274C15.6534 8.93226 16.2206 8.90453 16.6129 9.20955Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconVolumeOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconVolumeOff.eae7fa06fe9e64568decdf35a0b73cdd.svg";